import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ParticlesContainer from '../dashboard/ParticlesContainer';
import { withRouter } from "react-router";

const jumbotronStyle = {
    paddingBottom: '60px',
    paddingTop: '80px',
    boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",
    position: "relative",
    zIndex: "999",
}

const insideStyle = {
    position: "relative",
    zIndex: "999009",
}

const pStyle = {
    fontSize: '9px',
};

class PlansPricing extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div className="grey lighten-5" >

                <div className="card-panel white-text teal lighten-1" style={jumbotronStyle}>
                    <ParticlesContainer>
                    </ParticlesContainer>
                    <div className="container white-text" style={insideStyle}>
                        <h4>Plans & Pricing</h4>
                    </div>


                </div>

                <div className="mainpage container z-depth-0 ">
                    <div className="row"></div>


                    {/* space */}
                    <div className="row">
                        <table className="striped highlight responsive-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>FREE</th>
                                    <th>PRO</th>
                                    <th>PREMIUM</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>Price</td>
                                    <td>FREE</td>
                                    <td>10€/month</td>
                                    <td>15€/month</td>
                                </tr>
                                <tr>
                                    <td>NDA up to</td>
                                    <td>3 NDAs/month</td>
                                    <td>10 NDAs/month</td>
                                    <td>Unlimited</td>
                                </tr>
                                <tr>
                                    <td>Custom Template</td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                </tr>
                                <tr>
                                    <td>Share NDA</td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                </tr>
                                <tr>
                                    <td>Download NDA</td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                </tr>
                                <tr>
                                    <td>Customer Support</td>
                                    <td></td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                    <td><FontAwesomeIcon icon="check" size="lg" /></td>
                                </tr>
                                <tr>
                                    <td>Community</td>
                                    <td>Coming soon</td>
                                    <td>Coming soon</td>
                                    <td>Coming soon</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                    <div className="row"></div>
                    <div className="row"></div>
                    <div className="row"></div>
                    <div className="row">
                        <div className="col s6 m6 center">
                            <div className="center">
                                <NavLink className="waves-effect waves-light btn white-text lighten-1 teal" to='/payment'>Upgrade Your Plan
                                </NavLink>
                            </div>
                        </div>

                        <div className="col s6 m6 center">
                            <NavLink className="waves-effect waves-light btn grey-text lighten-1 transparent z-depth-0" to='/unsubscribe'>or Cancel Pro/Premium
                                </NavLink>
                        </div>
                    </div>
                    <div className="row"></div>
                    <div className="row"></div>
                    <div className="row"></div>
                    <div>
                        <p className="center" style={pStyle}>Disclaimer of Warranties</p>

                        <p style={pStyle}>ALL INFORMATION AVAILABLE AT OUR SITE IS PROVIDED ON “AS IS,” “WITH ALL FAULTS” AND “AS AVAILABLE” BASIS AND, TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, CUSARY.ME RUN BY INTERACTHUB GMBH  ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT OR NON-INFRINGEMENT, AND WARRANTIES IMPLIED FROM A COURSE OF PERFORMANCE OR COURSE OF DEALING. YOU EXPRESSLY AGREE THAT YOUR USE OF OUR SITE AND THE SERVICES IS AT YOUR SOLE RISK. WE DO NOT WARRANT THAT THE SERVICES YOU OBTAIN THROUGH OUR SITE WILL MEET YOUR EXPECTATIONS AND REQUIREMENTS, BE UNINTERRUPTED OR ERROR-FREE, WILL BE AVAILABLE FOR USE, WILL BE OF A CERTAIN QUALITY, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SITE OR THE SERVER ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR THAT THE SITE OR THE TECHNOLOGY THAT MAKES IT AVAILABLE, ARE IMMUNE TO HACKER ACTIVITY, ELECTRONIC OR NON-ELECTRONIC TAMPERING, COMPUTER CRIME OR THEFT. WE DO NOT WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE USE OR THE RESULTS OF THE USE OF THE SITE AND SERVICES IN TERMS OF THEIR CORRECTNESS, ACCURACY, RELIABILITY, TIMELINESS, COMPLETENESS, CURRENTNESS, OR OTHERWISE. YOU (AND NOT WE) ASSUME THE ENTIRE COST OF ALL NECESSARY SERVICING, REPAIR, OR CORRECTION.

                        YOU ARE SOLELY RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS AND INTERACTIONS WITH OTHERS. YOU UNDERSTAND CUSALY.ME RUN BY INTERACTHUB GMBH DOES NOT MAKE ANY ATTEMPT TO VERIFY THE STATEMENTS OF USERS POSTED ON THE SITE.

                        Some jurisdictions do not allow the exclusion of certain warranties. Accordingly, some of the above exclusions may not apply to you.
                    </p>
                    </div>

                    {/* space */}

                    <div className="row">
                    </div>
                </div >
            </div >
        )
    }
}

export default withRouter(PlansPricing);